/**
 *  Date    : 2019/11/7
 *  Author  : Weilin
 *  Declare : user
 */
import Immutable from 'seamless-immutable';

import appApi from '@/api/appapi';

const namespace = 'app';

export default {
  namespace,
  state: Immutable({
    templeList: [],
    appTypeList: [],
    raysToolList: []
  }),
  reducers: {
    update: (state, { data, field }) => state.merge({ [field]: data })
  },
  actions: {
    // 获取书刊分类
    getTempleList() {
      return {
        type: namespace + '/update/getTempleList',
        field: 'templeList',
        promise: appApi.getTempleList()
      };
    },
    getAppTypeList(payload) {
      return {
        type: namespace + '/update/getAppTypeList',
        field: 'appTypeList',
        promise: appApi.listByAppCreate(payload)
      };
    },
    getRaysToolList(payload) {
      return {
        type: namespace + '/update/getRaysToolList',
        field: 'raysToolList',
        promise: appApi.listPageRaysApp(payload)
      };
    }
  }
};
